;(function () {
  angular
    .module('contrast.user.settings')
    .controller('UserEditCtrl', UserEditCtrl)

  function UserEditCtrl(
    $scope,
    $q,
    $location,
    $routeParams,
    $translate,
    logger,
    csTemplates,
    dialogs,
    UserFactory,
    groupsApiConfig,
    GlobalFactory,
    RoleFactory,
    AuthFactory,
    sharedGroupService,
    UserService,
    ErrorService,
    GlobalService,
    PromiseService,
    FeaturesService,
    ROLES_LIST,
    AUTH_MODE
  ) {
    'ngInject'

    var readOnlySelected = false
    var expandUser = 'email,preferences,groups,role'
    var userDeleteUrl = 'views/settings/users/template/delete.tpl.html'
    var userUid = $routeParams.userUid
    var loadPerPage = 15
    var _searchKeywords = ''
    var validFreemiumRoles = ['admin']

    var translGlobal = {
      title_all_applications: $translate.instant('title_all_applications')
    }

    angular.extend($scope, {
      apps: [],
      model: {
        passwordvalid: true,
        roles: [],
        permissionLoading: true
      },
      select: {
        groups: [],
        date_formats: [],
        time_formats: [],
        time_zones: [],
        roles: [],
        roleOnChange: function (role) {
          $scope.user.role = role
          $scope.form.$pristine = false
        }
      },
      user: {
        org_management: true,
        groups: []
      },
      roleInvalid: [],
      quickFilters: [],
      selectedQuickFilter: {
        name: translGlobal.title_all_applications,
        filterType: 'ALL',
        count: '?'
      },
      quickFilterPromise: null,
      loadPromise: null,
      loadMatrixPromise: null
    })

    angular.extend($scope, {
      save: save,
      removeUser: removeUser,
      searchKeywords: searchKeywords,
      quickFilterSelect: quickFilterSelect,
      loadMore: loadMore,
      onRemoveGroup: onRemoveGroup,
      onSelectGroup: onSelectGroup,
      isInvalidRole: isInvalidRole,
      isOrgProtectionEnabled: UserService.isOrganizationProtectionEnabled,
      isAssignRoleViaSSOEnabled: isAssignRoleViaSSOEnabled
    })

    function init() {
      var label = GlobalService.getAttributeLabel()
      if (angular.isUndefined(label) || 0 === label.length) {
        $scope.model.label = 'Email'
      } else {
        $scope.model.label = label
      }

      $scope.loadPromise = $q
        .all([
          _getOrganizationalAccessGroups(),
          _getAuthMode(),
          _getDateFormats(),
          _getTimeFormats(),
          _getTimeZones(),
          _getRoles()
        ])
        .then(function () {
          var promises = []
          promises.push(_getUserInfo())
          promises.push(_loadUserMatrix(0))
          promises.push(_getApplicationQuickFilters())

          return $q.all(promises)
        })
        .catch(function (response) {
          ErrorService.processError(response)
        })
    }

    function _getAuthMode() {
      return AuthFactory.getAuthMode().then(function (response) {
        $scope.isUnManaged =
          response.data.auth_mode == AUTH_MODE.mode.AD ||
          response.data.auth_mode == AUTH_MODE.mode.LDAP
      }, ErrorService.processError)
    }

    function _getDateFormats() {
      return GlobalFactory.getDateFormats().then(
        function (response) {
          $scope.select.date_formats = response.data.date_formats
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getTimeFormats() {
      return GlobalFactory.getTimeFormats().then(
        function (response) {
          $scope.select.time_formats = response.data.time_formats
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getTimeZones() {
      return GlobalFactory.getTimeZones().then(
        function (response) {
          $scope.select.time_zones = response.data.timezones
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getOrganizationalAccessGroups() {
      return groupsApiConfig.getGroupsBase().then(
        function (response) {
          $scope.select.groups = response.data.groups
          sharedGroupService.formatOrganizationGroups($scope.select.groups)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getRoles() {
      return RoleFactory.getRoles().then(
        function (response) {
          $scope.select.roles = response.data.groups
          $scope.model.roles = response.data.groups

          if (UserService.isFreemiumOrganization()) {
            $scope.select.roles = $scope.select.roles.filter(function (role) {
              return validFreemiumRoles.indexOf(role.name) !== -1
            })
          }
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getUserInfo() {
      return UserFactory.getUser(userUid, expandUser).then(
        function (response) {
          var user = response.data.user

          $scope.user = {
            username: user.user_uid,
            first_name: user.first_name,
            last_name: user.last_name,
            date_format: user.preferences.date_format,
            time_format: user.preferences.time_format,
            time_zone: user.preferences.time_zone,
            enabled: user.enabled_org,
            api_only: user.api_only_org,
            enabled_system: user.enabled,
            api_only_system: user.api_only,
            org_management: user.org_management,
            role: user.role.group_id,
            protect: user.rasp_enabled
          }

          $scope.user.groups = []

          _.each(user.groups, function (userGroup) {
            var item = _.find($scope.select.groups, function (selectGroup) {
              return userGroup.group_id === selectGroup.group_id
            })
            if (item) {
              $scope.user.groups.push(item)
            }

            if (userGroup.readonly) {
              readOnlySelected = true
            }
          })

          $scope.roleInvalid = user.invalid_roles
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _loadUserMatrix(offset) {
      if ($scope.loadMatrixPromise) {
        PromiseService.cancelPromise($scope.loadMatrixPromise)
      }

      $scope.permissionLoading = true

      $scope.loadMatrixPromise = UserFactory.getUserApplicationMatrix(
        userUid,
        _searchKeywords,
        $scope.selectedQuickFilter.filterType,
        offset,
        loadPerPage
      ).then(
        function (response) {
          $scope.permissionLoading = false
          _.each(response.data.applications, function (app) {
            _.each(app.groups, function (group) {
              if (!app.noAccess && group.readonly) {
                var value = _.find(ROLES_LIST, function (roleList) {
                  return roleList.value == app.role
                })
                if (value) {
                  group.name = value.label
                }
              }
            })
          })

          $scope.totalApps = response.data.total
          $scope.apps.push(...response.data.applications)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )

      return $scope.loadMatrixPromise
    }

    function removeUser() {
      var transl = {
        title_pleaseConfirmAction: $translate.instant(
          'title_pleaseConfirmAction'
        ),
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel'),
        detail_unableToLoadDialog: $translate.instant(
          'detail_unableToLoadDialog'
        )
      }
      return csTemplates
        .loadAndInterpolate(userDeleteUrl, {
          firstName: $scope.user.first_name,
          lastName: $scope.user.last_name
        })
        .then(
          function (interpolatedStr) {
            var dlg = dialogs.confirm(
              transl.title_pleaseConfirmAction,
              interpolatedStr,
              {
                size: 'sm',
                yes: transl.action_delete,
                no: transl.action_cancel
              }
            )
            dlg.result.then(function () {
              UserFactory.deleteUser(userUid).then(
                function (response) {
                  logger.logSuccess(response.data.messages[0])
                  $location.path(UserService.buildUrl('/settings/users'))
                },
                function (result) {
                  ErrorService.processError(result)
                }
              )
            })
          },
          function () {
            logger.logError(transl.detail_unableToLoadDialog)
          }
        )
    }

    function save() {
      var form = {
        first_name: $scope.user.first_name,
        last_name: $scope.user.last_name,
        time_zone: $scope.user.time_zone,
        date_format: $scope.user.date_format,
        time_format: $scope.user.time_format,
        enabled: $scope.user.enabled,
        api_only: $scope.user.api_only,
        groups: [],
        role: $scope.user.role.group_id || $scope.user.role
      }

      _.each($scope.user.groups, function (group) {
        form.groups.push(group.group_id)
      })

      if ($scope.isOrgProtectionEnabled()) {
        form.protect = $scope.user.protect
      }

      UserFactory.editUser(userUid, form).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $location.path(UserService.buildUrl('/settings/users'))
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      _clear()

      _getApplicationQuickFilters()
      _loadUserMatrix(0)

      return _searchKeywords
    }

    function loadMore() {
      _loadUserMatrix($scope.apps.length)
    }

    function _getApplicationQuickFilters() {
      if ($scope.quickFiltersPromise) {
        PromiseService.cancelPromise($scope.quickFiltersPromise)
      }

      $scope.quickFiltersPromise = UserFactory.getApplicationQuickFilter(
        userUid,
        searchKeywords()
      )

      $scope.quickFiltersPromise.then(function (response) {
        $scope.quickFilters = response.data.filters

        $scope.selectedQuickFilter = $scope.quickFilters.find(function (
          filter
        ) {
          return filter.filterType == $scope.selectedQuickFilter.filterType
        })
      }, ErrorService.processError)

      return $scope.quickFiltersPromise
    }

    function onSelectGroup(item) {
      if (item.readonly && readOnlySelected) {
        $scope.user.groups = _.filter($scope.user.groups, function (group) {
          return !group.readonly || group.group_id == item.group_id
        })
      } else if (item.readonly && !readOnlySelected) {
        readOnlySelected = true
      }
    }

    function onRemoveGroup(item) {
      if (item.readonly) {
        readOnlySelected = false
      }
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      _clear()
      _getApplicationQuickFilters()
      return _loadUserMatrix(0)
    }

    function _clear() {
      $scope.apps = []
    }

    function isInvalidRole(role) {
      return (
        angular.isDefined($scope.roleInvalid) &&
        _.some($scope.roleInvalid, function (invalid) {
          return invalid.group_id == role.group_id
        })
      )
    }

    function isAssignRoleViaSSOEnabled() {
      return FeaturesService.isSplitFeatureFlagOn(
        'PROD-3575_assign_user_role_via_sso'
      )
    }

    init()
  }
})()
